export default {
  "userRisk.title": "会员风控管理",
  "userRisk.thead.riskId": "风险ID",
  "userRisk.thead.userId": "用户ID",
  "userRisk.thead.email": "邮箱",
  "userRisk.thead.userName": "用户名",
  "userRisk.thead.firstName": "名",
  "userRisk.thead.lastName": "姓",
  "userRisk.thead.inviterUserno": "推荐人编号",
  "userRisk.thead.inviterEmail": "推荐人邮箱",
  "userRisk.thead.inviterName": "推荐人姓名",
  "userRisk.thead.inviterFirstName": "推荐人名",
  "userRisk.thead.inviterLastName": "推荐人姓",
  "userRisk.thead.riskTypes": "风险类型",
  "userRisk.thead.riskContent": "风险内容",
  "userRisk.thead.riskTime": "风险时间",
  "userRisk.thead.userStatus": "用户状态",
  "userRisk.thead.inviterStatusDesc": "推荐人状态",
  "userRisk.thead.action": "操作",
  "userRisk.disableUser": "禁用用户",
  "userRisk.enableUser": "启用用户",
  "userRisk.disableInviter": "禁用推荐人",
  "userRisk.enableInviter": "启用推荐人",
  "userRisk.confirm": "确认",
  "userRisk.cancel": "取消",
  "userRisk.confirmDisableUser": "确定要禁用此用户吗？",
  "userRisk.confirmDisableInviter": "确定要禁用此推荐人吗？",
  "userRisk.copySuccess": "复制成功",
  "userRisk.search.disable": "禁用",
  "userRisk.search.enable": "启用",
};
